import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
import { composePageTitle } from './Common';
import Footer from './components/Footer';
import Header from './components/Header';
import Application from './config/application';
import { PageUrl } from './Constants';

const Destinations = () => {
  return (
    <div id="main-wrapper">
      <Helmet title={composePageTitle('Destinations')} />
      <Header />
      <section className="page-header page-header-dark bg-secondary">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-8">
              <h1>Destinations</h1>
            </div>
            <div className="col-md-4">
              <ul className="breadcrumb justify-content-start justify-content-md-end mb-0">
                <li>
                  <RouterLink to={PageUrl.HOME}>Home</RouterLink>
                </li>
                <li className="active">Destinations </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <div id="content">
        <div className="container">
          <div className="bg-white shadow-md rounded p-4">
            <h2>
              Book Your Dream Destination with Affordable Flight Deals
            </h2>
            <p>
              Planning a trip abroad to the USA, Canada, or any destination worldwide? With <strong>{Application.ORG_DISPLAY_NAME}</strong>, securing your flight is simpler and more budget-friendly than ever before. Whether it’s for business, leisure, or visiting family, we make it easy to find the perfect flight with just a few clicks.{' '}
            </p>
            <p>
              Our platform provides an extensive range of flights from numerous major cities, putting you in full control of your travel itinerary. Whether you need round-trip, one-way, or multi-city tickets, you can book them conveniently from home. Select Economy or Business Class depending on your budget and comfort preferences—all easily accessible from your laptop or mobile device.{' '}
            </p>
            <p>
              Before confirming your reservation, be sure to check out our <strong>latest deals and offers</strong>. We frequently update our website with exclusive discounts and unpublished fares designed to help you save even more on your travel costs.{' '}
            </p>
            <div>
              <h3>Unlock Exclusive Deals & Special Offers</h3>
              <ol>
                <li>
                  Whether you're organizing a multi-city adventure or a straightforward getaway, our offers are crafted to help you save significantly. These deals are available for a limited time only, so be sure to check regularly and book early to secure the best prices.{' '}
                </li>
                <li>
                  We also offer real-time flight schedule updates. Although occasional changes to departure or arrival times may happen, you can count on us to keep you informed with every update.
                  {' '}
                </li>
                <li>
                  With {Application.ORG_DISPLAY_NAME}, your adventure starts with simple, cost-effective, and dependable flight bookings. Begin planning your trip now and secure a deal that suits your budget perfectly.
                  {' '}
                </li>
                <li>
                  Flight landing and take-off times may vary slightly from the schedule. However, any significant delays or changes will be updated promptly and continuously.{' '}
                </li>
              </ol>
            </div>
          </div>
        </div>
        <section className="section">
          <div className="container">
            <h2 className="text-9 fw-500 text-center">Popular Destinations</h2>
            <p className="lead text-center mb-4">
              World's leading Flight Booking website.
            </p>
            <div className="row g-4 banner">
              <div className="col-md-8">
                <div className="item rounded h-100">
                  <div className="caption text-center">
                    <h2 className="text-7">Dubai</h2>
                  </div>
                  <div className="banner-mask"></div>
                  <img
                    className="img-fluid h-100"
                    src={`${Application.STORAGE_URL_STATIC_ASSETS_PATH}/dubai.jpg`}
                    alt="Dubai"
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="row g-4">
                  <div className="col-12">
                    <div className="item rounded">
                      <div className="caption text-center">
                        <h2>India</h2>
                      </div>
                      <div className="banner-mask"></div>
                      <img
                        className="img-fluid"
                        src={`${Application.STORAGE_URL_STATIC_ASSETS_PATH}/india.jpg`}
                        alt="India"
                      />
                    </div>
                  </div>
                  <div className="col-12 mt-lg-3">
                    <div className="item rounded">
                      <div className="caption text-center">
                        <h2>London</h2>
                      </div>
                      <div className="banner-mask"></div>
                      <img
                        className="img-fluid"
                        src={`${Application.STORAGE_URL_STATIC_ASSETS_PATH}/lodon.jpg`}
                        alt="London"
                      />{' '}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row banner g-4 mt-0 mb-2 mt-lg-3">
              <div className="col-md-4">
                <div className="row g-4">
                  <div className="col-12">
                    <div className="item rounded">
                      <div className="caption text-center">
                        <h2>Bangkok</h2>
                      </div>
                      <div className="banner-mask"></div>
                      <img
                        className="img-fluid"
                        src={`${Application.STORAGE_URL_STATIC_ASSETS_PATH}/bangkok.jpg`}
                        alt="Bangkok"
                      />{' '}
                    </div>
                  </div>
                  <div className="col-12 mt-lg-3">
                    <div className="item rounded">
                      <div className="caption text-center">
                        <h2>NYC</h2>
                      </div>
                      <div className="banner-mask"></div>
                      <img
                        className="img-fluid"
                        src={`${Application.STORAGE_URL_STATIC_ASSETS_PATH}/newyork.jpg`}
                        alt="NYC"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-8">
                <div className="item rounded h-100">
                  <div className="caption text-center">
                    <h2 className="text-7">Singapore</h2>
                  </div>
                  <div className="banner-mask"></div>
                  <img
                    className="img-fluid h-100"
                    src={`${Application.STORAGE_URL_STATIC_ASSETS_PATH}/singapore.jpg`}
                    alt="Singapore"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Destinations;
